module.exports = __webpack_public_path__ + "static/media/probitDark.19db6c2e.png";